import { useHead } from "@unhead/react";
import { UnheadProvider, createHead } from "@unhead/react/client";
import { TemplateParamsPlugin } from "unhead/plugins";

import { useTranslation } from "@punto/frontend-shared/i18n/i18next";

const head = createHead({
  plugins: [TemplateParamsPlugin],
});

export const HeadProvider = ({ children }: React.PropsWithChildren) => {
  return <UnheadProvider head={head}>{children}</UnheadProvider>;
};

const DefaultTitle = () => {
  const { t } = useTranslation();

  useHead({
    titleTemplate: `%s %separator %siteName`,
    templateParams: {
      separator: "·",
      siteName: t("Header.brand_name"),
    },
  });

  return null;
};

const Title = ({ children }: { children: string | undefined }) => {
  useHead({
    title: children,
  });

  return null;
};

export * from "@unhead/react";

export { DefaultTitle, Title };
